import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4504c31a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attachments-border p-2" }
const _hoisted_2 = {
  class: "ml-1 mt-1",
  style: {"font-weight":"700"}
}
const _hoisted_3 = { class: "order-attachments-grid" }
const _hoisted_4 = { class: "new attachments" }
const _hoisted_5 = { class: "attachment" }
const _hoisted_6 = { class: "body" }

import DropZone from "@/components/admin/content/editor/DropZone.vue"
import OrderAttachment from "./OrderAttachment.vue"
import UploadProgress from "@/components/common/upload-progress/UploadProgress.vue"
import { OrderAttachmentType } from "@/interfaces/global/attachments"

type Props = {
  canEdit: boolean,
  canAddMore: boolean,
  attachments: OrderAttachmentType[],
  uploadProgress: number|null,
  attachmentsHeader: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AddAttachmentsLayout',
  props: {
    canEdit: { type: Boolean },
    canAddMore: { type: Boolean },
    attachments: {},
    uploadProgress: {},
    attachmentsHeader: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _renderSlot(_ctx.$slots, "title", {}, () => [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.attachmentsHeader), 1)
    ]),
    _renderSlot(_ctx.$slots, "helpText", {}, () => [
      _withDirectives(_createElementVNode("p", { class: "help ml-1 mt-1" }, _toDisplayString(_ctx.$t("orderAttachmentHelpText")), 513), [
        [_vShow, _ctx.canEdit]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (attachment, i) => {
        return (_openBlock(), _createBlock(OrderAttachment, {
          key: i,
          "file-name": attachment.fileName,
          "content-url": attachment.contentUrl,
          "can-edit": _ctx.canEdit || !attachment.id,
          onDelete: ($event: any) => (_ctx.$emit('delete', 
                          { id: attachment.id, displayOrder: attachment.displayOrder })),
          onReplace: ($event: any) => (_ctx.$emit('replace', 
                          { file: $event, id: attachment.id, displayOrder: attachment.displayOrder}))
        }, null, 8, ["file-name", "content-url", "can-edit", "onDelete", "onReplace"]))
      }), 128))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(DropZone, {
            accept: "*/*",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('upload', $event)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('dropFileMessage')), 1)
            ], undefined, true),
            _: 1
          })
        ])
      ])
    ], 512), [
      [_vShow, _ctx.canAddMore]
    ]),
    _createVNode(UploadProgress, { percentage: _ctx.uploadProgress }, null, 8, ["percentage"])
  ]))
}
}

})